import request from '@/services/request'
import { getApiUrl } from '@/utils/tool'

export function getTransaction(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/transaction',
    method: 'post',
    data: object,
    customConfig: {
      noLoading: true
    }
  })
}

